import { SessionActionTypes, SetUserDataAction } from 'app/dux/session/actionTypes';
import { AccessTokenPayload, AuthState } from 'app/dux/session/types';
import jwtDecode from 'jwt-decode';

export function setUserData(authState: AuthState): SetUserDataAction {
    // const accessToken = authState.delegateToken || authState.accessToken;
    const accessToken = authState.delegate.access_token || authState.access_token;

    let accessTokenPayload: AccessTokenPayload;
    try {
        accessTokenPayload = jwtDecode<Record<string, unknown>>(accessToken) as unknown as AccessTokenPayload;
    } catch (e) {
        throw new Error('Unable to parse JWT token ' + accessToken + ': ' + e.message);
    }

    return {
        type: SessionActionTypes.SET_USER_DATA,
        authState,
        accessTokenPayload: accessTokenPayload,
        delegateCompanyId: authState.delegate.claims.company_id,
    };
}
